import { THEMES } from './config';
import { mentionRegexp } from './components/Comments/utils';
export const EMPTY_ARRAY = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => { };
const getStorage = (useSession) => useSession ? window.sessionStorage : window.localStorage;
/**
 * Set value into storage
 * @param {string} name — param name
 * @param {unknown?} value — value to save
 * @param {boolean?} useSession — use session storage instead localstorage
 * @returns {boolean} — value successfully saved
 */
export const storageSet = (name, value, useSession) => {
    const storage = getStorage(useSession);
    try {
        const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
        storage.setItem(name, stringValue);
        return true;
    }
    catch (err) {
        console.error(err);
    }
    return false;
};
/**
 * Get value from storage
 * @param {string} name — param name
 * @param {unknown?} defaultValue — value to return if value in storage is not found
 * @param {boolean?} useSession — use session storage instead localstorage
 * @returns {unknown} — value returned from storage
 */
export const storageGet = (name, defaultValue, useSession) => {
    const storage = getStorage(useSession);
    let value;
    // First trying to read from the storage
    try {
        value = storage.getItem(name);
    }
    catch (err) {
        console.error(err);
        return defaultValue;
    }
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        value = JSON.parse(value);
    }
    catch (err) {
        // There is no special in this error. Value can be already defined as string/undefined and so on.
        // At this case we will return it below
    }
    return value || defaultValue;
};
/**
 * Get current theme
 * @returns {string} — dark | light
 */
export const getCurrentTheme = () => (document.documentElement.hasAttribute(THEMES.light) ? 'light' : 'dark');
/**
 * Format given date according US format
 *
 * @param {Date} date - Date to format
 * @returns {string} - Formatted date like MM/DD/YYYY
 */
export const formatDateTime = (date) => new Intl.DateTimeFormat('en-US').format(date);
const regExp = new RegExp(mentionRegexp, 'g');
/**
 * Returns an array of mentions (user ids).
 *
 * @param {String} text - text that may contain mentions
 * @returns {Array<String>} - an array of mentions (user ids)
 */
export const getMentions = (text) => {
    const matches = (text.match(regExp) || []).map((str) => str.substring(1));
    return matches;
};
/**
 * Returns an array of user ids.
 *
 * @param {Object} comment - comment
 * @returns {Array<String>} - an array of user ids
 */
export const getUserIdsFromComment = (comment) => {
    const userIds = getMentions(comment.text);
    if (!userIds.includes(comment.author)) {
        userIds.push(comment.author);
    }
    return userIds;
};
